export default __webpack_public_path__ + "images/okta-white.68639b8b2b3d4c9054af877de35ebb1d.png";